import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbCheckboxModule,
  NbSelectModule,
  NbSpinnerModule,
  NbAlertModule,
  NbActionsModule
} from '@nebular/theme';

import { UserListComponent } from './user-list/user-list.component';
import { UserEditDialogComponent } from './user-edit-dialog/user-edit-dialog.component';
import { UserDeleteDialogComponent } from './user-delete-dialog/user-delete-dialog.component';
import { RoleLabelPipe } from 'src/app/pipes/role-label.pipe';

@NgModule({
  declarations: [
    UserListComponent,
    UserEditDialogComponent,
    UserDeleteDialogComponent,
    RoleLabelPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NbButtonModule,
    NbCardModule,
    NbIconModule,
    NbCheckboxModule,
    NbSelectModule,
    NbSpinnerModule,
    NbAlertModule,
    NbActionsModule
  ],
  exports: [
    UserListComponent,
    RoleLabelPipe
  ]
})
export class UsersModule { }
